import { Marquee } from '@/components/shared/marquee';

function SpotifyIcon() {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden
    >
      <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm4.586 14.424a.622.622 0 01-.857.207c-2.348-1.435-5.304-1.76-8.785-.964a.622.622 0 11-.277-1.215c3.809-.87 7.077-.496 9.712 1.115.294.18.387.566.207.857zm1.223-2.722a.779.779 0 01-1.072.257c-2.687-1.652-6.785-2.131-9.965-1.166a.779.779 0 01-.97-.519.78.78 0 01.52-.969c3.632-1.102 8.147-.568 11.23 1.329a.779.779 0 01.257 1.068zm.105-2.835c-3.223-1.914-8.54-2.09-11.618-1.156a.935.935 0 11-.543-1.79c3.532-1.072 9.404-.865 13.115 1.338a.934.934 0 11-.954 1.608z" />
    </svg>
  );
}

function AppleMusicIcon() {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden
    >
      <path d="M12 3v10.55A4 4 0 1014 17V5h4V3h-6z" />
    </svg>
  );
}

function YouTubeIcon() {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden
    >
      <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
    </svg>
  );
}

function SoundCloudIcon() {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden
    >
      <path d="M11.56 8.87V17h8.76c1.68 0 3.04-1.36 3.04-3.04 0-1.68-1.36-3.04-3.04-3.04-.1 0-.2.005-.3.014a5.23 5.23 0 00-1.024-3.068 5.234 5.234 0 00-7.436-.992zM0 14.637c0 1.302.978 2.363 2.187 2.363S4.374 15.94 4.374 14.637c0-1.302-.978-2.363-2.187-2.363S0 13.335 0 14.637zm5.03-1.667c-.48 0-.87.425-.87.95v1.43c0 .524.39.95.87.95s.87-.426.87-.95v-1.43c0-.525-.39-.95-.87-.95zm2.19-.7c-.565 0-1.023.5-1.023 1.117v1.683c0 .617.458 1.118 1.023 1.118.565 0 1.022-.501 1.022-1.118v-1.683c0-.617-.457-1.117-1.022-1.117zm2.19-.44c-.61 0-1.104.54-1.104 1.206v2.07c0 .666.494 1.206 1.104 1.206.61 0 1.104-.54 1.104-1.206v-2.07c0-.667-.494-1.207-1.104-1.207z" />
    </svg>
  );
}

function BandcampIcon() {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden
    >
      <path d="M0 18.75l7.437-13.5H24l-7.438 13.5z" />
    </svg>
  );
}

function TwitchIcon() {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden
    >
      <path d="M11.571 4.714h1.715v5.143H11.57zm4.715 0H18v5.143h-1.714zM6 0L1.714 4.286v15.428h5.143V24l4.286-4.286h3.428L22.286 12V0zm14.571 11.143l-3.428 3.428h-3.429l-3 3v-3H6.857V1.714h13.714z" />
    </svg>
  );
}

function PatreonIcon() {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden
    >
      <path d="M15.386.524c-4.764 0-8.64 3.876-8.64 8.64 0 4.75 3.876 8.613 8.64 8.613 4.75 0 8.614-3.864 8.614-8.613C24 4.4 20.136.524 15.386.524M.612 23.476h4.363V.524H.612z" />
    </svg>
  );
}

function VimeoIcon() {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden
    >
      <path d="M23.977 6.416c-.105 2.338-1.739 5.543-4.894 9.609-3.268 4.247-6.026 6.37-8.29 6.37-1.409 0-2.578-1.294-3.553-3.881L5.322 11.4C4.603 8.816 3.834 7.522 3.01 7.522c-.179 0-.806.378-1.881 1.132L0 7.197c1.185-1.044 2.351-2.084 3.501-3.128C5.08 2.701 6.266 1.984 7.055 1.91c1.867-.18 3.016 1.1 3.447 3.838.465 2.953.789 4.789.971 5.507.539 2.45 1.131 3.674 1.776 3.674.502 0 1.256-.796 2.265-2.385 1.004-1.589 1.54-2.797 1.612-3.628.144-1.371-.395-2.061-1.614-2.061-.574 0-1.167.121-1.777.391 1.186-3.868 3.434-5.757 6.762-5.637 2.473.06 3.628 1.664 3.48 4.807z" />
    </svg>
  );
}

function BehanceIcon() {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden
    >
      <path d="M6.938 4.503c.702 0 1.34.06 1.92.188.577.13 1.07.33 1.485.61.41.28.733.65.96 1.12.225.47.34 1.05.34 1.73 0 .74-.17 1.36-.507 1.86-.336.5-.837.9-1.502 1.22.906.26 1.576.72 2.022 1.37.448.66.665 1.45.665 2.36 0 .75-.13 1.39-.41 1.93-.28.55-.67 1-1.16 1.35-.48.348-1.05.6-1.69.767-.636.17-1.3.254-1.99.254H0V4.51l6.938-.007zm-.21 5.58c.574 0 1.05-.135 1.424-.404.37-.27.555-.69.555-1.26 0-.31-.057-.57-.17-.78-.11-.21-.267-.375-.46-.5-.19-.125-.415-.21-.67-.257-.257-.047-.526-.07-.806-.07H3.53v3.27h3.197zm.15 5.836c.31 0 .6-.03.865-.086.27-.06.5-.155.704-.29.2-.13.36-.31.477-.54.116-.23.174-.52.174-.87 0-.69-.197-1.18-.592-1.48-.394-.3-.924-.45-1.592-.45H3.53v3.716h3.348zm8.1-1.95c.317.304.77.455 1.364.455.424 0 .79-.106 1.097-.32.305-.212.493-.44.566-.683h2.34c-.374 1.16-1.005 1.996-1.892 2.508-.886.51-1.953.768-3.207.768-1.48 0-2.657-.47-3.53-1.412-.874-.94-1.31-2.235-1.31-3.885 0-1.595.45-2.884 1.35-3.864.9-.98 2.08-1.47 3.544-1.47 1.466 0 2.633.5 3.503 1.5.87 1 1.306 2.41 1.306 4.23v.373H14.58c.07.807.29 1.4.61 1.8l-.212-.02zm2.37-5.05c-.26-.295-.656-.442-1.19-.442-.36 0-.65.06-.874.18-.226.12-.408.26-.552.43-.143.17-.245.35-.3.54-.06.19-.093.365-.1.525h3.56c-.07-.55-.283-.95-.544-1.233zM15.59 7.2h4.39v1.21h-4.39V7.2z" />
    </svg>
  );
}

function KofiIcon() {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden
    >
      <path d="M23.881 8.948c-.773-4.085-4.859-4.593-4.859-4.593H.723c-.604 0-.679.798-.679.798s-.082 7.324-.022 11.822c.164 2.424 2.586 2.672 2.586 2.672s8.267-.023 11.966-.049c2.438-.426 2.683-2.566 2.658-3.734 4.352.24 7.422-2.831 6.649-6.916zm-11.062 3.511c-1.246 1.453-4.011 3.976-4.011 3.976s-.121.119-.31.023c-.076-.057-.108-.09-.108-.09-.443-.441-3.368-3.049-4.034-3.954-.709-.965-1.041-2.7-.091-3.71.951-1.01 3.005-1.086 4.363.407 0 0 1.565-1.782 3.468-.963 1.904.82 1.832 3.011.723 4.311zm6.173.478c-.928.116-1.682.028-1.682.028V7.284h1.77s1.971.551 1.971 2.638c0 1.913-.985 2.667-2.059 3.015z" />
    </svg>
  );
}

function InstagramIcon() {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden
    >
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
    </svg>
  );
}

function SubstackIcon() {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden
    >
      <path d="M22.539 8.242H1.46V5.406h21.08v2.836zM1.46 10.812V24L12 18.11 22.54 24V10.812H1.46zM22.54 0H1.46v2.836h21.08V0z" />
    </svg>
  );
}

const PLATFORMS = [
  { name: 'Spotify', color: '#1DB954', Icon: SpotifyIcon },
  { name: 'Apple Music', color: '#FC3C44', Icon: AppleMusicIcon },
  { name: 'YouTube', color: '#FF0000', Icon: YouTubeIcon },
  { name: 'SoundCloud', color: '#FF5500', Icon: SoundCloudIcon },
  { name: 'Bandcamp', color: '#1DA0C3', Icon: BandcampIcon },
  { name: 'Twitch', color: '#9146FF', Icon: TwitchIcon },
  { name: 'Patreon', color: '#FF424D', Icon: PatreonIcon },
  { name: 'Vimeo', color: '#1AB7EA', Icon: VimeoIcon },
  { name: 'Behance', color: '#1769FF', Icon: BehanceIcon },
  { name: 'Ko-fi', color: '#29ABE0', Icon: KofiIcon },
  { name: 'Instagram', color: '#E4405F', Icon: InstagramIcon },
  { name: 'Substack', color: '#FF6719', Icon: SubstackIcon },
];

function PlatformChip({ name, color, Icon }: (typeof PLATFORMS)[number]) {
  return (
    <span
      className="landing-proof__chip"
      style={{ '--brand': color } as React.CSSProperties}
      role="img"
      aria-label={name}
    >
      <Icon />
    </span>
  );
}

export function LandingProof() {
  return (
    <div className="landing-proof">
      <Marquee
        pauseOnHover
        repeat={4}
        style={{ '--duration': '35s', '--gap': '40px' }}
      >
        <span className="landing-proof__everywhere">works everywhere</span>
        {PLATFORMS.map(({ name, color, Icon }) => (
          <PlatformChip key={name} name={name} color={color} Icon={Icon} />
        ))}
      </Marquee>
    </div>
  );
}
